'use strict';

var _require = require('./defaults'),
    investorProfile = _require.investorProfile,
    assetClassReturns = _require.assetClassReturns,
    returnProfiles = _require.returnProfiles,
    defaults = _require.defaults;

var adjustDefaults = require('./adjust-defaults');
var scaling = require('./lumpsum-scaling');

module.exports = {
  investorProfile: investorProfile,
  assetClassReturns: assetClassReturns,
  returnProfiles: returnProfiles,
  defaults: defaults,
  adjustDefaults: adjustDefaults,
  scaling: scaling
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/cmw-goaltools/dist/config/index.js
// module id = 70
// module chunks = 0